import { useQuery } from "@apollo/client";
import { PublicUserOrganizationDocument } from "../../../../../../../../__generated__/graphql";

export default function usePublicUserOrganization(
  userOrganizationId?: string | null
) {
  const { data, loading, error, refetch } = useQuery(
    PublicUserOrganizationDocument,
    {
      variables: { userOrganizationId: userOrganizationId ?? "" },
      skip: !userOrganizationId,
      fetchPolicy: "no-cache",
    }
  );

  return {
    data: data?.publicUserOrganization,
    loading,
    error,
    refetch,
  };
}
